<mat-icon matTooltip="{{ 'GridTable.Filter.FilterBool' | translate }}" [matMenuTriggerFor]="menu">filter_alt</mat-icon>
<mat-menu #menu="matMenu" class="p-3">
    <form [formGroup]="boolForm" (click)="$event.stopPropagation();">
        <div class="col">
            <mat-form-field>
              <mat-label>{{ 'GridTable.Filter.ChooseValue' | translate }}</mat-label>
                <mat-select [formControl]="boolControl" [value]="boolControl">
                  <mat-option [value]="true">
                    {{ (useLabels ? labelTrue : 'GridTable.Filter.Yes') | translate }}
                  </mat-option>
                  <mat-option [value]="false">
                    {{ (useLabels ? labelFalse : 'GridTable.Filter.No') | translate }}
                  </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
    <div class="col" style="display: flex; justify-content: flex-end;">
        <mat-icon matTooltip="{{ 'GridTable.Filter.Cancel' | translate }}" style="cursor: pointer;" color="primary"
            (click)="onCancel()">
            clear
        </mat-icon>
        <mat-icon matTooltip="{{ 'GridTable.Filter.ApplyFilter' | translate }}" style="cursor: pointer;" color="primary"
            (click)="onSubmit($event)">
            check
        </mat-icon>
        <mat-icon matTooltip="{{ 'GridTable.Filter.Clear' | translate }}" style="cursor: pointer;" color="primary"
            *ngIf="this.currentValue | async" (click)="onClear()">
            delete
        </mat-icon>
    </div>
</mat-menu>
